import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface DrawerButtonsProps {
  onSave?: () => void;
  onCancel: () => void;
  disabled?: boolean;
  onlyCancel?: boolean;
  onlySave?: boolean;
  labelSave?: string;
  labelCancel?: string;
}

export default function DrawerButtons({
  onSave,
  onCancel,
  disabled = false,
  onlyCancel = false,
  onlySave = false,
  labelSave,
  labelCancel,
}: DrawerButtonsProps) {
  const { t } = useTranslation(['common']);

  const showOnlySave = onlySave && !onlyCancel;
  const showOnlyCancel = onlyCancel && !onlySave;
  const showBoth = !onlySave && !onlyCancel;

  return (
    <Stack direction="row" justifyContent="flex-end" alignItems="baseline" spacing={2} sx={{ mb: 2 }}>
      {(showOnlyCancel || showBoth) && (
        <Button variant="secondary" onClick={onCancel}>
          {labelCancel || t('common:cancel')}
        </Button>
      )}
      {(showOnlySave || showBoth) && (
        <Button variant="primary" onClick={onSave} disabled={disabled}>
          {labelSave || t('common:save')}
        </Button>
      )}
    </Stack>
  );
}
